import { render, staticRenderFns } from "./TestItemPair.vue?vue&type=template&id=5cef2b3a&scoped=true&"
import script from "./TestItemPair.vue?vue&type=script&lang=js&"
export * from "./TestItemPair.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cef2b3a",
  null
  
)

export default component.exports